export default {
  "root": "_root_1ndcm_1"
};import "ni:sha-256;PxMiwREyrtrZ1ar_B5jZHi7rkcK89-Y2y8PYBAt72Rw";